import { create } from "../../../common/utils/zustand_state_manager";
import { ICommonsService } from "../../../common/data/services/commons_service";
import { CommonsService } from "../../../common/data/services/commons_service_impl";

/**
 * useCommonServices
 */

type State = {
  commonsService: ICommonsService,
};

export const useCommonServices = create<State>((set, get) => ({
  commonsService: new CommonsService(),
}));